import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCoastSymbol = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M31.8633 21.9626C30.926 27.6648 25.9854 32 20.0098 32C13.3897 32 8 26.6298 8 19.9902C8 13.3507 13.3897 8 20.0098 8C25.9658 8 30.926 12.3548 31.8633 18.0374H28.9341C28.0358 13.9365 24.3841 10.8706 20.0098 10.8706C14.9715 10.8706 10.8902 14.952 10.8902 19.9902C10.8902 25.0285 14.9715 29.1098 20.0098 29.1098C24.3841 29.1098 28.0358 26.0439 28.9341 21.943H31.8633V21.9626ZM23.9935 21.9626C23.271 23.4272 21.7673 24.4426 20.0293 24.4426C18.2913 24.4426 16.7876 23.4272 16.0651 21.9626H12.9601C13.8194 25.048 16.6509 27.3133 20.0098 27.3133C23.3686 27.3133 26.2002 25.048 27.0594 21.9626H23.9935Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCoastSymbol);
export default ForwardRef;
